var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a-page-header",
        { staticClass: "page-header", on: { back: _vm.handleBack } },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: { click: _vm.handleBack },
              slot: "title",
            },
            [
              _vm._v("\n      返回\n      "),
              _vm._l(_vm.titleList, function (item, index) {
                return _c("span", { key: index }, [
                  _c(
                    "span",
                    {
                      style: {
                        color:
                          index == _vm.titleList.length - 1 ? "#297ede" : "",
                      },
                    },
                    [_vm._v(_vm._s(item))]
                  ),
                  index < _vm.titleList.length - 1
                    ? _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/"),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _c(_vm.componentList[_vm.componentType], {
        tag: "component",
        attrs: {
          type: _vm.componentType,
          classId: _vm.classId,
          titleList: _vm.titleList,
          recordData: _vm.recordData,
        },
        on: { addTitleList: _vm.addTitleList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }